import { render, staticRenderFns } from "./deleteServiceImpl.vue?vue&type=template&id=6cc06404"
import script from "./deleteServiceImpl.vue?vue&type=script&lang=js"
export * from "./deleteServiceImpl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports